// import { isEmpty } from 'lodash'

const app = state => state.app
const device = state => state.app.device
const sidebar = state => state.app.sidebar
const effect = state => state.app.effect
const menuitems = state => state.menu.items
const auth = state => state.auth
const customer = (state) => state.customer
const tokenRecoveryPassword = (state) => state.recoveryPassword.token

export {
  app,
  device,
  sidebar,
  effect,
  menuitems,
  auth,
  customer,
  tokenRecoveryPassword
}



// WEBPACK FOOTER //
// ./src/store/getters.js